import {
    Assets,
    Container,
    Sprite,
    Text,
} from 'pixi.js';
import { CARD_BASE, CARD_ELEMENT_BASE, CARD_ELEMENT_ID_TO_COLOR, CARD_ELEMENT_VERTEX_POS, CARD_TEAM_COLOR } from '../CommonAssets';
import { FONT_1 } from '../GameConst';

export class CardObject extends Container {
    constructor(isSelf, cardData){
        super();
        this.isSelf = isSelf;
        this.cardData = cardData;
        this.setData();
    }

    setData(){
        const base = new Sprite(Assets.get(CARD_BASE.name));
        base.anchor.set(0.5);
        base.scale.set(1.4);
        base.tint = '0x000000';
        this.addChild(base);
        for(let i = 0; i < 5; i++)
        {
            const elmenetId = this.cardData.getVertexElementId(i);
            const elementValue = this.cardData.getVertexValue(i);

            const rotation = CARD_ELEMENT_VERTEX_POS[i].angle * Math.PI / 180;

            const elementBase = new Sprite(Assets.get(CARD_ELEMENT_BASE.name));
            elementBase.anchor.set(0.5, 1);
            this.addChild(elementBase);
            
            elementBase.tint = CARD_ELEMENT_ID_TO_COLOR[elmenetId];
            elementBase.scale.set(1.2, 1.3);
            elementBase.rotation = rotation;
            elementBase.x = 0;//sprite.width * 0.5;
            elementBase.y = 0;//sprite.height * 0.5;
            const num = new Text(elementValue, {
                fontFamily: FONT_1,
                fontSize: 60,
                stroke: '#000000',
                strokeThickness: 10,
                fill: 'white',
            });
            num.anchor.set(0.5);
            this.addChild(num);
            num.x = CARD_ELEMENT_VERTEX_POS[i].x;
            num.y = CARD_ELEMENT_VERTEX_POS[i].y;
            num.rotation = rotation;
        }
        const teamBaseLine = new Sprite(Assets.get(CARD_BASE.name));
        teamBaseLine.anchor.set(0.5);
        teamBaseLine.scale.set(0.6);
        teamBaseLine.tint = '0x000000';
        this.addChild(teamBaseLine);
        const teamBase = new Sprite(Assets.get(CARD_BASE.name));
        teamBase.anchor.set(0.5);
        teamBase.scale.set(0.5);
        teamBase.tint = CARD_TEAM_COLOR[(this.isSelf == true ? 1: 2)];
        this.addChild(teamBase);
        if(this.cardData.imageUrl){
            const key = `token_${this.cardData.tokenId}`;
            const chara = new Sprite(Assets.get(key));
            chara.anchor.set(0.5);
            chara.width = teamBase.width;
            chara.height = teamBase.height;
            const mask = new Sprite(Assets.get(CARD_BASE.name));
            mask.anchor.set(0.5);
            mask.scale.set(0.5);
            chara.mask = mask;
            this.addChild(chara);
            this.addChild(mask);
        }
    }

    select(isSelect){
        if(!this.coverLayer)
        {
            this.coverLayer = new Sprite(Assets.get(CARD_BASE.name));
            this.coverLayer.anchor.set(0.5);
            this.coverLayer.scale.set(1.4);
            this.coverLayer.tint = '0x000000';
            this.coverLayer.alpha = 0.75;
            this.addChild(this.coverLayer);
        }
        // if(!this.outline){
        //     this.outline = new Sprite(Assets.get(CARD_BASE_OUTLINE.name));
        //     this.outline.anchor.set(0.5);
        //     this.addChild(this.outline);
        // }
        if(isSelect)
        {
            this.coverLayer.visible = true;
            // this.outline.visible = true;
        }
        else
        {
            this.coverLayer.visible = false;
            // this.outline.visible = false;
        }
    }
}
